/**
 * Created by sara on 2/8/16.
 */

(function () {
    'use strict';

    // @ngInject
    function TOSControllerCtor($modalInstance, AnalyticsService) {
        this.$modalInstance = $modalInstance;

        this.__objectType = 'TOSController';
        AnalyticsService.trackPageView(this, 'onboarding tos modal');

        this.tabs = [
            {title: "Terms of Service", panel: "crop-tabs-1"},
            {title: "Privacy", panel: "crop-tabs-2"},
        ];

        this.activeTab = "Terms of Service";
    }

    Controllers.TOSController = Class(Controllers.BaseController, {
        constructor: TOSControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

        changeActive: function changeActive(tab) {
            var oldTab = this.activeTab;
            this.activeTab = tab.title;
        },

    });
}());